/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import { formatDate } from 'src/utils/dates';
import notice from 'src/common/components/Notice';
import React, { useState, useEffect } from 'react';
import { searchAPI } from 'src/api/modules/search';
import { organsAPI } from 'src/api/modules/organs';
import { createR } from 'src/utils/UniqueIdGenerator';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import { sessionsAPI } from 'src/api/modules/sessions';
import FullTable from 'src/common/components/FullTable';
import { usePagination } from 'src/hooks/usePagination';
import PageLayout from 'src/common/components/PageLayout';
import UtilInputs from 'src/common/components/UtilInputs';
import { institutionsAPI } from 'src/api/modules/institutions';
import { defaultFilter, filter_form, columns } from './utils/list_data';
import HighResolutionView from '../Track/HightResolution.js/HighResolutionView';

const Search = () => {
	const [data, setData] = useState([]);
	const [filter, setFilter] = useState(defaultFilter);
	//const [triggerRequest, setTriggerRequest] = useState(false);
	const [organs, setOrgans] = useState([]);
	const [sessions, setSessions] = useState([]);
	const [institutions, setInstitutions] = useState([]);
	const [resolutionSelected, setResolutionSelected] = useState(null);
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	const [arrayOrgan, setArrayOrgan] = useState([]);
	const [accessAll, setAccessAll] = useState(false);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	const showEverything = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];
	const {
		pagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
		handlePagination,
	} = usePagination();

	useEffect(() => {
		getOrgans();
		getInstitutions();
		let newArray = [];
		reduxOrgan.forEach((item) => {
			newArray.push(item.value);
		});
		setArrayOrgan(newArray);

		if (showEverything.includes(systemLevelRole) === true) setAccessAll(true);
		else setAccessAll(false);
	}, []);

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;

		if (name === 'organ') {
			getSessionsByOrgan(value);
		}

		setFilter({ ...filter, [name]: value });
	};

	const getSessionsByOrgan = (organFromDropdown) => {
		let sessionByOrgan = [];
		setSessions([]);
		sessionsAPI
			.getByOrgan(organFromDropdown)
			.then((response) => {
				if (response.sesiones.length > 0) {
					response.sesiones.forEach((item) => {
						sessionByOrgan.push({
							value: item.id,
							text: item.numero_sesion,
						});
					});
					setSessions(sessionByOrgan);
				} else {
					notice(
						'No se encontraron sesiones para el organo seleccionado',
						'warning'
					);
				}
			})
			.catch((e) => notice('Error en la solicitud'));
	};

	const onConfirmFilter = () => {
		let date;
		if (filter.date === null) date = '';
		if (filter.date !== null) date = filter.date.toLocaleDateString('en-GB');

		notice('Buscando Resultados', 'info');
		setData([]);

		searchAPI
			.getSearchByFilters(
				filter.pClave,
				filter.organ,
				filter.session,
				filter.area,
				date,
				filter.status,
				pagination,
				currentPage
			)
			.then((response) => {
				if (response.codigo === 'SAOC-400' || response.codigo === 'SAOC: 500')
					notice(JSON.parse(JSON.stringify(response.mensaje)));
				else if (response.busquedaAvanzada.length > 0) {
					let newResponse = [];
					response.busquedaAvanzada.forEach((item) => {
						//We assigned a unique ID instance (just for the table) for each item with length 16 (could be less)
						newResponse.push({
							...item,
							status:
								item.estatusResolucion === 'PE'
									? 'Pendiente'
									: item.estatusResolucion === 'AS'
									? 'Asignada'
									: item.estatusResolucion === 'EP'
									? 'En proceso'
									: item.estatusResolucion === 'AT'
									? 'Atendida'
									: '',
							dateSesion: item.fechaSesion.split('-').reverse().join('/'),
							dateCompliance: item.fechaCumplimiento
								.split('-')
								.reverse()
								.join('/'),
							id: createR(16),
						});
					});

					setData(newResponse);
					setTotalResults(response.totalRegistros);
				} else {
					notice('No se encontraron resultados', 'warning');
				}
			})
			.catch((e) => {
				if (isDev) {
					if (e.response.data === undefined || e.response.data === '') {
						notice('Ha ocurrido un error con su petición');
					} else notice(JSON.parse(JSON.stringify(e.response.data.mensaje)));
				} else notice('Ha ocurrido un error con su petición');
			});
	};

	const getOrgans = () => {
		if (showEverything.includes(systemLevelRole) === true) {
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setOrgans(getAllOrgans(response));
					}
				})
				.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
		} else {
			setOrgans(reduxOrgan);
		}
	};

	const getInstitutions = () => {
		institutionsAPI
			.get('unidadAdministrativa')
			.then((response) => {
				if (response && response.length > 0) {
					let institutionsFlag = [];
					response.forEach((ele) => {
						institutionsFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setInstitutions([...(institutionsFlag || [])]);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const onClear = () => {
		setFilter(defaultFilter);
		setData([]);
		setSessions([]);
	};

	const onEye = (id) => {
		setResolutionSelected(id);
	};

	const expandRow = (data) => {
		let textdata = (
			<div style={{ maxWidth: '100%' }}>
				<p>
					<b>RESOLUCIÓN: </b> {data.resolucion}
				</p>
				<p>
					<b>TEXTO: </b> {data.textoResolucion}
				</p>
				<p>
					<b>ÓRGANO COLEGIADO: </b> {data.organoColegiado}
				</p>
				<p>
					<b>NÚMERO DE SESIÓN: </b> {data.numeroSesion}
				</p>
				<p>
					<b>FECHA DE SESIÓN: </b> {data.dateSesion}
				</p>
				<p>
					<b>FECHA DE CUMPLIMIENTO: </b> {data.dateCompliance}
				</p>
				<p>
					<b>RESPONSABLE: </b> {data.responsable}
				</p>
				<p>
					<b>ÁREA RESPONSABLE: </b> {data.areaResponsable}
				</p>
				<p>
					<b>ACOMPAÑANTE: </b> {data.acompaniante}
				</p>
				<p>
					<b>ÁREA DE ACOMPAÑAMIENTO: </b> {data.areaAcompaniante}
				</p>
				<p>
					<b>DOCUMENTOS: </b> {data.documentos}
				</p>
				<p>
					<b>ESTATUS: </b> {data.status}
				</p>
			</div>
		);
		return textdata;
	};

	// useEffect(() => {
	// 	if (triggerRequest) {
	// 		onConfirmFilter();
	// 		setTriggerRequest(false);
	// 	}
	// }, [triggerRequest]);

	useEffect(() => {
		onConfirmFilter();
	}, [pagination, currentPage]);

	return (
		<>
			{resolutionSelected !== null && (
				<HighResolutionView
					id={resolutionSelected}
					setId={setResolutionSelected}
					//setTriggerRequest={setTriggerRequest}
				/>
			)}
			<PageLayout title="Búsqueda Avanzada">
				<UtilInputs
					formValues={filter}
					inputValues={filter_form(
						organs,
						sessions,
						institutions,
						onConfirmFilter,
						onClear
					)}
					onValuesChange={handleChangeFilter}
				/>
				<FullTable
					title="Resultados de Búsqueda"
					items={data}
					columns={columns(onEye, arrayOrgan, accessAll)}
					ExcelFileName={`Busqueda_Avanzada${formatDate('P p')}.xls`}
					expand={true}
					dataRow={expandRow}
					showPagination
					handlePagination={handlePagination}
					sizePerPageTable={pagination}
					totalPages={totalResults}
					currentPage={currentPage}
					setCurrentPage={setCurrentPage}
				/>
			</PageLayout>
		</>
	);
};

export default Search;
